function postMessage(windowObject, message) {
  if (!windowObject) {
    return
  }

  windowObject.postMessage(message, '*')
}

export default postMessage
